export const POSTHOG_EVENTS = {
  START_EVALUATION: "landing_page_start_evaluation",
  START_EVALUATION_DESPRE_NIS2: "despre_nis2_start_evaluation",
  STEP_1_CUI: "step_1_send_cui",
  STEP_2_CONFIRM_DATA: "step_2_confirm_data",
  STEP_2_EDIT_DATA: "step_2_edit_data",
  STEP_3_SELECTED_SERVICES: "step_3_selected_services",
  STEP_4_NIS_CLASSIFICATION: "step_3_accepted_classification",
  STEP_5_CONFIRM_DATA: "step_5_confirm_data",
  STEP_5_ACCEPT_OBLIGATION: "step_5_accept_obligation",
  STEP_5_REPORT_GENERATION: "step_4_generated_report",
  STEP_5_POST_LINKEDIN: "step_5_post_linkedin",
};
